import { useTranslation } from "react-i18next";

import { Sidenav } from "../../components";
import { DashboardUsageDropPageFilters } from "./DashboardUsageDropPageFilters";
import { DashboardUsageDropPageTable } from "./DashboardUsageDropPageTable";
import { Breadcrumb } from "flowbite-react";

export const DashboardUsageDropPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-full flex-1 flex-row">
      <Sidenav />

      <div className="animation-slide-up-lil-bounce flex w-full flex-col items-center">
        <div className="flex h-screen flex-1 flex-col overflow-y-scroll">
          <div className="m-5 inline-flex h-20 flex-col items-start justify-start gap-6">
            <Breadcrumb>
              <Breadcrumb.Item className="opacity-50" href="/dashboard">
                {t("pages.dashboard.title")}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {t("pages.dashboardUsageDrop.title")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <div className="flex flex-col items-start justify-start gap-0.5">
              <div className="inline-flex items-center justify-start gap-2">
                <div className="text-4xl font-bold leading-10 text-black">
                  {t("pages.dashboardUsageDrop.title")}
                </div>
              </div>
            </div>
          </div>

          <div className="mx-5 mb-5  flex flex-col items-start justify-start gap-2.5 rounded-lg bg-white pb-4 shadow">
            <DashboardUsageDropPageFilters setSelectedFilter={() => {}} />
            <DashboardUsageDropPageTable />
          </div>
        </div>
      </div>
    </div>
  );
};
